// @ts-expect-error: implicitly has an 'any' type
import buildFormatLongFn from 'date-fns/locale/_lib/buildFormatLongFn';
import enUsLocale from 'date-fns/locale/en-US';

// From https://www.localeplanet.com/icu/ur/index.html
// and https://www.unicode.org/cldr/cldr-aux/charts/28/verify/dates/ur.html

const dateFormats = {
  full: 'EEEE، MMMM d، y',
  long: 'MMMM d، y',
  medium: 'MMM d، y',
  short: 'd/M/yy',
};

const dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}',
};

export const formatLong: Locale['formatLong'] = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full',
  }),
  time: enUsLocale.formatLong!.time,
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full',
  }),
};
